import { Button, Grid2, Stack, Tab, Tabs, Typography } from "@mui/material";
import ContainerLoading from "../components/ContainerLoading";
import { IconBuildingStore, IconPlus } from "@tabler/icons-react";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import PageHeader from "../components/PageHeader";
import { listStoreProducts } from "../services/products";
import ProductsTableComponent from "../components/ProductsTableComponent";
import PartnersStore from "../components/PartnersStore";
import { useNavigate } from "react-router";

const Marketplace = () => {
  const navigate = useNavigate();
  const [openPartnersStore, setOpenPartnersStore] = useState(false);
  const [value, setValue] = useState("1");

  const handleChangeValue = (
    _event: React.SyntheticEvent,
    newValue: string
  ) => {
    setValue(newValue);
  };

  const { data, isLoading, isFetching, refetch } = useQuery({
    queryKey: ["listStoreProducts"],
    queryFn: async () => await listStoreProducts({}),
    initialData: [],
  });

  const refetchAll = () => {
    refetch();
  };

  const loading = isLoading || isFetching;

  return (
    <ContainerLoading loading={loading}>
      <Grid2 container spacing={2} padding={2}>
        <PageHeader
          title="Produtos"
          subtitle="Informações gerais dos produtos."
          options={
            <Stack
              sx={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: { xs: "flex-start", lg: "flex-end" },
                gap: 2,
              }}
            >
              <Button
                variant="contained"
                sx={{ gap: 0.5 }}
                onClick={() => setOpenPartnersStore(true)}
              >
                <IconBuildingStore size={18} />
                <Typography variant="body2" fontSize={{ xs: 12 }}>
                  Lojas parceiras
                </Typography>
              </Button>
              <Button
                variant="contained"
                sx={{ gap: 0.5 }}
                onClick={() => navigate("/products/register")}
              >
                <IconPlus size={18} />
                <Typography variant="body2" fontSize={{ xs: 12 }}>
                  Cadastrar produto
                </Typography>
              </Button>
            </Stack>
          }
        />
        <Grid2 size={12}>
          <Tabs
            sx={{
              borderBottom: 1,
              borderColor: "divider",
              marginBottom: 2,
            }}
            onChange={handleChangeValue}
            value={value}
            textColor="inherit"
            variant="scrollable"
            scrollButtons="auto"
          >
            {/* <Tab label="Relatórios" value="1" /> */}
            <Tab label="Produtos" value="1" />
          </Tabs>
        </Grid2>
        {value === "1" && (
          <Grid2 size={12}>
            <ProductsTableComponent
              data={data as any}
              refetch={() => refetchAll()}
            />
          </Grid2>
        )}
      </Grid2>
      <PartnersStore
        open={openPartnersStore}
        onClose={() => setOpenPartnersStore(false)}
      />
    </ContainerLoading>
  );
};

export default Marketplace;
